import React from 'react';
import { useTranslation } from 'react-i18next';
import { getControlStyle } from '../../helper';
import CommonAction from '../../../Pages/Library/DPP/Library/TemplateComponent/CommonAction';
import ReadMoreLess from './ReadMoreLess';

export function Html(props) {
  const { t } = useTranslation('common');

  const { otherConfiguration, fromForm, dataIndex, editingInput, deleteItem, ckeditorData, dppAddEditAccess, isProductArchived } = props;

  const combinedStyles = getControlStyle(otherConfiguration);
  const subHeaderStyle = {
    textAlign: otherConfiguration?.subHeaderAlign || 'left',
    color: otherConfiguration?.subHeaderColor || '#000000',
    fontWeight: otherConfiguration?.subHeaderBold ? 'bold' : 'normal',
    fontFamily: otherConfiguration?.subHeaderBold ? 'Aktiv Grotesk Medium' : 'inherit',
  };

  const htmlTitleStyle = {
    textAlign: otherConfiguration?.htmlTitleAlign || 'left',
    color: otherConfiguration?.htmlTitleColor || '#000000',
    fontWeight: otherConfiguration?.htmlTitleBold ? 'bold' : 'normal',
    fontFamily: otherConfiguration?.htmlTitleBold ? 'Aktiv Grotesk Medium' : 'inherit',
    fontSize: otherConfiguration?.htmlTitleFontSize || 'inherit',
  };

  return (
    <div className="heading-control">
      {!props?.htmlTitle && !ckeditorData ? (
        <div className="empty-heading">{t('DPP.CONTROL.HTML.HTML_TITLE')}</div>
      ) : (
        <>
          <h3 className="mb-2" style={htmlTitleStyle}>
            {props?.htmlTitle}
          </h3>
          <p className="mb-2" style={subHeaderStyle}>
            {props?.subHeaderTitle}
          </p>
        </>
      )}

      <div style={combinedStyles}>
        <ReadMoreLess ckeditorData={ckeditorData} />
      </div>

      {fromForm && (
        <CommonAction
          editingInput={editingInput}
          deleteItem={deleteItem}
          dataIndex={dataIndex}
          dppAddEditAccess={dppAddEditAccess}
          isProductArchived={isProductArchived}
        />
      )}
    </div>
  );
}
export default Html;
